"use client"

import React from "react";
import {cn} from "@/lib/utils";
import {PortableText} from "@portabletext/react";
import {richTextComponent} from "@/sanity/sanityPortableText";
import {PortableTextBlock} from "sanity";
import {GROQImage} from "@/sanity/lib/types";
import {motion} from "framer-motion";

const fadeInStagger = (index: number, baseDelay = 0.1) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" as const },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: baseDelay + (index * 0.1) }
});

export default function NumberedColoredList({
  items,
  className = "",
  numberBackgroundColor = "bg-[#D9F9B9]",
  textBackgroundColor = "bg-[#F3F2F1]"
}: {
  items: {
    text: PortableTextBlock[];
    icon?: GROQImage;
  }[];
  className?: string;
  numberBackgroundColor?: string;
  textBackgroundColor?: string;
}) {
  if (!items || items.length === 0) return null;

  return (
    <ul className={cn(
      "flex flex-col gap-[.5rem]",
      className,
    )}>
      {items.map((item, index) => (
        <motion.li
          key={index}
          {...fadeInStagger(index)}
          className="flex"
        >
          <div className={cn(
            "w-[4rem] flex-shrink-0 flex items-center justify-center",
            numberBackgroundColor
          )}>
            <p className="font-geistmono leading-none mb-0 text-[2rem]">
              {index + 1}
            </p>
          </div>

          {item?.text && (
            <div className={cn(
              "richtext richtext-start prose-p:text-[2rem] prose-p:leading-[1.2] prose-strong:font-medium prose-strong:text-black prose-p:text-black grow p-[1rem]",
              textBackgroundColor
            )}>
              <PortableText
                value={item.text}
                components={richTextComponent}
              />
            </div>
          )}
        </motion.li>
      ))}
    </ul>
  );
}